const plans = [
  {
    name: 'Basic',
    description: 'basic subscription free',
    monthlyProductId: undefined,
    annualProductId: undefined,
    monthlyPlan: undefined,
    annualPlan: undefined,
    benefits: [
      'Up to 20 image or text to hologram conversions per month (up to 20MB per hologram)',
      'Up to 30 minutes of Liteforms chat time per month',
      '1 customizable Liteforms name, pronouns, voice, personality, and avatar selection',
      '1 custom image to avatar (coming soon)',
      'Public cast of Liteforms characters',
      'Access to Unity, Unreal, Blender, WebXR plugins & libraries',
    ],
  },
  {
    name: 'Plus',
    description: '1 year of + subscription free',
    monthlyProductId: undefined,
    annualProductId: undefined,
    monthlyPlan: undefined,
    annualPlan: undefined,
    benefits: [
      'Up to 100 image or text to hologram conversions per month (up to 50MB per hologram)',
      'Up to 5 hours of Liteforms chat time per month',
      'Ability to make custom hologram playlists',
      'Wi-Fi cloud syncing of hologram playlists for offline playback',
      '2 custom image to avatar (coming soon)',
      '2 customizable Liteforms name, pronouns, voice, personality, and avatar selection',
      'Public cast of Liteforms characters',
      'Privacy controls for holograms',
      'Access to Unity, Unreal, Blender, WebXR Plugins & libraries',
    ],
  },
  {
    name: 'Creator',
    description: 'creator subscription ',
    monthlyProductId: undefined,
    annualProductId: undefined,
    monthlyPlan: undefined,
    annualPlan: undefined,
    benefits: [
      'Up to 200 image or text to hologram conversions per month (up to 50MB per hologram)',
      'Up to 5 hours of Liteforms chat time per month',
      'Ability to make custom hologram playlists',
      'Wi-Fi cloud syncing of hologram playlists for offline playback',
      '5 custom Liteform avatars (VRMs) / custom image to avatar (coming soon)',
      '5 customizable Liteforms name, pronouns, voice, personality, and avatar selection',
      'Public cast of Liteforms characters',
      'Privacy controls for holograms',
      'Access to Unity, Unreal, Blender, WebXR Plugins & libraries',
    ],
  },
  {
    name: 'Pro',
    description: 'pro subscription ',
    monthlyProductId: undefined,
    annualProductId: undefined,
    monthlyPlan: undefined,
    annualPlan: undefined,
    benefits: [
      'Up to 500 image or text to hologram conversions per month (up to 50MB per hologram)',
      'Up to 100 hours of Liteforms chat time per month',
      'Ability to make custom hologram playlists',
      'Wi-Fi cloud syncing of hologram playlists for offline playback',
      '10 custom Liteform avatars (VRMs) / custom image to avatar (coming soon)',
      '5 customizable Liteforms name, pronouns, voice, personality, and avatar selection',
      'Public cast of Liteforms characters',
      'Privacy controls for holograms',
      'Access to Unity, Unreal, Blender, WebXR Plugins & libraries',
    ],
  },
  // {
  //   name: 'Enterprise',
  //   description: 'enterprise subscription ',
  //   monthlyProductId: undefined,
  // annualProductId: undefined,
  // monthlyPlan: undefined,
  // annualPlan: undefined,
  //   benefits: [
  //     'Unlimited image or text to hologram conversions per month (up to 250MB per hologram)',
  //     'Unlimited hours of Liteforms chat time',
  //     'Unlimited customizable Liteforms - name, pronouns, voice, personality, and avatar selection',
  //     'Custom LLM integration for Liteforms',
  //     'Custom avatars for Liteforms',
  //     'Custom backdrops for Liteforms',
  //     'Custom voices for Liteforms',
  //     'Public cast of Liteforms characters',
  //   ],
  //   plans: [],
  // },
];

class RechargeWidget extends HTMLElement {
  constructor() {
    super();
    this.plans = [...plans];
    this.container = this.querySelector('#recharge-widget-container');
    this.formattedPricesContainer = this.querySelector('#recharge-formatted-prices');
    this.formattedPrices = JSON.parse(this.formattedPricesContainer.text);
    this.selectedPlan = {};
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.isVisible = this.container.dataset.isVisible === 'true';
    this.hasSixMonthSubscriptionFree = this.container.dataset.sixMonthSubscription === 'true';
    this.subscriptionsCollection = JSON.parse(this.container.dataset.collection);

    const interval = setInterval(async () => {
      if (window.ReChargeWidget) {
        clearInterval(interval);
        const productIds = this.subscriptionsCollection.map((product) => product.id);
        const { fetchProduct } = window.ReChargeWidget.api;

        const rechargeProducts = await Promise.all(
          productIds.map((productId) =>
            fetchProduct(productId, {
              version: '2022-06',
            })
          )
        );

        this.plans.forEach((plan) => {
          const monthlyProduct = this.subscriptionsCollection.find(
            (product) =>
              product.title.toLowerCase().includes(plan.name.toLowerCase()) &&
              product.title.toLowerCase().includes('monthly')
          );

          const annualProduct = this.subscriptionsCollection.find(
            (product) =>
              product.title.toLowerCase().includes(plan.name.toLowerCase()) &&
              product.title.toLowerCase().includes('annual')
          );

          if (monthlyProduct) {
            const rechargeProduct = rechargeProducts.find(
              (rechargeProduct) => rechargeProduct.external_product_id == monthlyProduct.id
            );
            const monthlyPlan = rechargeProduct.plans[0];
            const monthlyPrices = this.formattedPrices.find((fp) => fp.id == monthlyProduct.id);

            plan.monthlyProductId = monthlyProduct.id;
            plan.monthlyProductVariantId = monthlyProduct.variants[0].id;
            plan.monthlyProductFormattedPrice = monthlyPrices.price;
            plan.monthlyProductTotalPrice = monthlyPrices.planPricePlusProductPrice;
            plan.monthlyPlan = {
              ...monthlyPlan,
              ...rechargeProduct.variants[0].prices[0].plans[0],
            };
          }

          if (annualProduct) {
            const rechargeProduct = rechargeProducts.find(
              (rechargeProduct) => rechargeProduct.external_product_id == annualProduct.id
            );
            const annualPlan = rechargeProduct.plans[0];
            const annualPrices = this.formattedPrices.find((fp) => fp.id == annualProduct.id);

            plan.annualProductId = annualProduct.id;
            plan.annualProductVariantId = annualProduct.variants[0].id;
            plan.annualProductFormattedPrice = annualPrices.price;
            plan.annualProductTotalPrice = annualPrices.planPricePlusProductPrice;
            plan.annualPlan = {
              ...annualPlan,
              ...rechargeProduct.variants[0].prices[0].plans[0],
            };
          }

          if (plan.name === 'Plus') {
            const sixMonthSubscription = this.subscriptionsCollection.find(subscription => subscription.title.toLowerCase().includes('6 months free'));
            const rechargeProduct = rechargeProducts.find(
              (rechargeProduct) => rechargeProduct.external_product_id == sixMonthSubscription.id
            );
            const sixMonthPlan = rechargeProduct.plans[0];

            plan.sixMonthProductId = sixMonthSubscription.id;
            plan.sixMonthProductVariantId = sixMonthSubscription.variants[0].id;
            plan.sixMonthPlan = {
              ...sixMonthPlan,
              ...rechargeProduct.variants[0].prices[0].plans.find((plan) => plan.id === sixMonthPlan.id),
            };
          }
        });

        this.loadAddToCartFormSubmitEvent();

        debugger;
        if (this.isVisible) {
          this.renderContent();
          this.loadEvents();
        } else if (this.hasSixMonthSubscriptionFree) {
          this.selectSixMonthFreePlan();
        }
      }
    }, 500);
  }

  selectSixMonthFreePlan() {
    const plusPlan = this.plans.find((plan) => plan.name === 'Plus');

    this.changeSelectedPlan(plusPlan.sixMonthPlan.external_plan_id, plusPlan.sixMonthProductVariantId);
  }

  renderContent() {
    this.plans.forEach((plan) => {
      const planDiv = `
        <div class='recharge-widget__tier'>
          <div class='recharge-widget__tier-heading'>
            <div class='recharge-widget__title-wrapper'>
              <div class='recharge-widget__select-icon'></div>
              <p class='recharge-widget__tier-title'>
                buy • <strong>Looking Glass ${plan.name}</strong>
              </p>
            </div>

            <div class='recharge-widget__price-wrapper'>
              <p class='recharge-widget__price'>${plan.monthlyProductTotalPrice}</p>
              <p class='recharge-widget__description'>${plan.description}</p>
            </div>
          </div>

          <div class='recharge-widget__tier-body'>
            <div class='recharge-widget__tier-plans-wrapper'>
              <div class='recharge-widget__tier-selected-plan selected-plan-monthly'></div>
              
              <!-- Monthly -->
              <div 
                class="recharge-widget__tier-plan selected"
                data-plan-type="monthly"
                data-plan-id="${plan.monthlyPlan.external_plan_id}"
                data-product-variant-id="${plan.monthlyProductVariantId}"
                data-product-total-price="${plan.monthlyProductTotalPrice}"
              >
                <p class="plan-name">Monthly</p>
                <p class="plan-price">${plan.monthlyProductFormattedPrice}</p>
              </div>
              
              <!-- Annual -->
              <div 
                class="recharge-widget__tier-plan"
                data-plan-type="annual"
                data-plan-id="${plan.annualPlan.external_plan_id}"
                data-product-variant-id="${plan.annualProductVariantId}"
                data-product-total-price="${plan.annualProductTotalPrice}"
              >
                <p class="plan-name">Annual</p>
                <p class="plan-price">${plan.annualProductFormattedPrice}</p>
              </div>
            </div>

            <div class='recharge-widget__tier-benefits'>
              <ul class='recharge-widget__benefits-list'>
                ${plan.benefits
                  .map((benefit) => {
                    return `
                      <li class='recharge-widget__benefit'>${benefit}</li>
                    `;
                  })
                  .join('')}
              </ul>
            </div>
          </div>
        </div>
      `;

      this.container.insertAdjacentHTML('beforeend', planDiv);
    });
  }

  loadEvents() {
    this.tierElements = this.container.querySelectorAll('.recharge-widget__tier');
    this.planElements = this.container.querySelectorAll('.recharge-widget__tier-plan');

    this.tierElements.forEach((input) => {
      input.addEventListener('click', this.handleTierSelection.bind(this));
    });

    this.planElements.forEach((input) => {
      input.addEventListener('click', this.handlePlanSelection.bind(this));
    });
  }

  loadAddToCartFormSubmitEvent() {
    const addToCartForms = document.querySelectorAll('.buy-buttons form[data-type="add-to-cart-form"]');
    addToCartForms.forEach((form) => {
      form.addEventListener('submit', this.handleAddToCartFormSubmit.bind(this));
    });
  }

  async handleAddToCartFormSubmit(event) {
    event.preventDefault();
    console.log("okkk")
    const productForms = document.querySelectorAll('.buy-buttons product-form');
    const formIndex = window.innerWidth < 750 ? 0 : 1;
    const { planId, productVariantId } = this.selectedPlan;

    if (planId && productVariantId) {
      const formData = {
        id: productVariantId,
        selling_plan: planId,
        quantity: 1,
      };

      productForms[formIndex].submitButton.classList.add('loading');
      productForms[formIndex].querySelector('.loading__spinner').classList.remove('hidden');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        const responseData = await response.json();

        productForms[formIndex].onSubmitHandler(event);
      } catch (error) {
        console.error(error);
      }
    } else {
      productForms[formIndex].onSubmitHandler(event);
    }
  }

  handlePlanSelection(event) {
    event.stopPropagation();
    const { currentTarget } = event;
    const { parentElement } = currentTarget;

    if (!currentTarget.classList.contains('selected')) {
      const plans = parentElement.querySelectorAll('.recharge-widget__tier-plan');
      const planBackdrop = parentElement.querySelector('.recharge-widget__tier-selected-plan');

      plans.forEach((plan) => {
        plan.classList.remove('selected');
      });

      currentTarget.classList.add('selected');
      planBackdrop.classList.remove('selected-plan-monthly', 'selected-plan-annual');
      planBackdrop.classList.add(`selected-plan-${currentTarget.dataset.planType}`);
      this.changeSelectedPlan(
        currentTarget.dataset.planId,
        currentTarget.dataset.productVariantId,
        currentTarget.dataset.productTotalPrice
      );
    }
  }

  handleTierSelection(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const selectedPlan = currentTarget.querySelector('.recharge-widget__tier-plan.selected');

    this.tierElements.forEach((tierElement) => {
      tierElement.classList.remove('selected');
    });

    currentTarget.classList.add('selected');
    this.changeSelectedPlan(
      selectedPlan.dataset.planId,
      selectedPlan.dataset.productVariantId,
      selectedPlan.dataset.productTotalPrice
    );
  }

  changeSelectedPlan(planId, productVariantId, productTotalPrice) {
    this.selectedPlan = { planId, productVariantId };

    if (productTotalPrice) {
      this.container.querySelector('.recharge-widget__tier.selected .recharge-widget__price').innerHTML =
        productTotalPrice;
    }
  }
}

customElements.define('recharge-widget', RechargeWidget);
